import * as jQuery from 'jquery';
import * as _ from 'underscore';
import { UtilityService } from '../../../../core/utility/services/utility.service';

import { Component, Input, OnInit } from '@angular/core';

import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CtvFeaturedNetworksComponent } from '../ctv-featured-networks/ctv-featured-networks.component';

@Component({
	selector: 'app-ctv-featured-networks-r1',
	styleUrls: ['./ctv-featured-networks-r1.component.css'],
	templateUrl: './ctv-featured-networks-r1.component.html'
})
export class CtvFeaturedNetworksR1Component extends CtvFeaturedNetworksComponent implements OnInit {
	@Input() colorsconfig: any;
	public tableConfig: any;
	public version: string;
	// 'colcount' is the number of networks to be shown
	@Input() colcount: any;
	public downloadIcon: boolean | string = false;
	protected colorPalette: ColorPalette;
	public itemsPerPage: number;
	public isR8: boolean;
	public isr103: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService);
	}
	getClassName(index: number): string {
		if (index > 1 && index % 2 === 0 && this.version !== 'r7') {
			return 'breakClass';
		} else if (index > 0 && index % 5 === 0 && this.version === 'r7') {
			return 'breakClass';
		}
	}
	ngAfterContentChecked(): void {
		// Called after every check of the component's or directive's content.
		// Add 'implements AfterContentChecked' to the class.
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r7') {
			jQuery('.pager .goToPrevious').addClass('primary-color-bg');
			jQuery('.pager .goToNext').addClass('primary-color-bg');
			jQuery('.pager .pages.current').addClass('primary-color-bg');
			jQuery('.pager .pages').addClass('primary-color-border');
		}
	}

	ngOnInit(): void {
		this.isR8 = this.analyticsDataModel.config.version.toLowerCase() == 'r8';
		super.ngOnInit();
		this.colorsconfig =
			typeof this.colorsconfig === 'string' ? JSON.parse(decodeURI(this.colorsconfig)) : this.colorsconfig;
		this.version = this.analyticsDataModel.config.version.toLowerCase();
		this.tableConfig = this.downloadConfiguration;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.itemsPerPage = this.colcount != 'undefined' && this.colcount != 'null' ? this.colcount : 10;
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.isr103 =
			this.analyticsDataModel.config.partner.directoryName === 'default-r103' ||
			this.analyticsDataModel.config.partner.directoryName === 'entravision-r103';
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.tableConfig.csvQueryKey ? this.tableConfig.csvQueryKey : this.key,
			this.tableConfig.downloadFileName ? this.tableConfig.downloadFileName : this.tableConfig.fileName
		);
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
}
